// Register the Illuminate Faith service worker at app entry.
//
// Runs once per page load, outside React, so every visitor picks it up — not
// just users who happen to hit the push-notification prompt on /chat.
//
// Responsibilities:
//   1. Register /sw.js with updateViaCache: 'none' so iOS Safari revalidates
//      the worker file instead of serving a stale cached copy.
//   2. Call registration.update() immediately and every 30 min thereafter so
//      long-lived tabs discover new deploys without the user quitting Safari.
//   3. When a replacement SW takes over (controllerchange on a page that
//      already had a controller) OR the SW posts back its SW_UPDATED message,
//      reload the tab so it pulls the new index.html + hashed bundles.
//
// First-time visitors (no previous controller) don't trigger a reload — their
// content is already fresh.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  let hadPrevController = !!navigator.serviceWorker.controller
  let reloading = false

  const reload = () => {
    if (!hadPrevController || reloading) return
    reloading = true
    window.location.reload()
  }

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    reload()
    hadPrevController = true
  })

  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data?.type === 'SW_UPDATED') reload()
  })

  navigator.serviceWorker
    .register('/sw.js', { scope: '/', updateViaCache: 'none' })
    .then(reg => {
      reg.update().catch(() => {})
      setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000)
    })
    .catch(() => {})
}
